import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { DashboardService } from '../../services/dashboard';
import { DashboardData, Balance } from '../../types';

// 异步actions
export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchData',
  async (days: number = 30, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getDashboardData(days);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || '获取仪表盘数据失败');
    }
  }
);

export const fetchBalance = createAsyncThunk(
  'dashboard/fetchBalance',
  async (_, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getBalance();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || '获取余额信息失败');
    }
  }
);

// Note: Backend doesn't support getTransactionCharts endpoint yet
// export const fetchTransactionCharts = createAsyncThunk(
//   'dashboard/fetchCharts',
//   async (params: { period?: 'day' | 'week' | 'month'; currency?: string }, { rejectWithValue }) => {
//     try {
//       const response = await DashboardService.getTransactionCharts(params.period, params.currency);
//       return response;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || '获取图表数据失败');
//     }
//   }
// );

interface DashboardState {
  data: DashboardData | null;
  balance: Balance | null;
  charts: any;
  loading: boolean;
  chartsLoading: boolean;
  balanceLoading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  data: null,
  balance: null,
  charts: null,
  loading: false,
  chartsLoading: false,
  balanceLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetDashboard: (state) => {
      state.data = null;
      state.balance = null;
      state.charts = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // 获取仪表盘数据
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action: PayloadAction<DashboardData>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // 获取余额信息
    builder
      .addCase(fetchBalance.pending, (state) => {
        state.balanceLoading = true;
      })
      .addCase(fetchBalance.fulfilled, (state, action: PayloadAction<Balance>) => {
        state.balanceLoading = false;
        state.balance = action.payload;
      })
      .addCase(fetchBalance.rejected, (state, action) => {
        state.balanceLoading = false;
        state.error = action.payload as string;
      });

    // Note: Chart fetching disabled until backend supports it
    // builder
    //   .addCase(fetchTransactionCharts.pending, (state) => {
    //     state.chartsLoading = true;
    //   })
    //   .addCase(fetchTransactionCharts.fulfilled, (state, action) => {
    //     state.chartsLoading = false;
    //     state.charts = action.payload;
    //   })
    //   .addCase(fetchTransactionCharts.rejected, (state, action) => {
    //     state.chartsLoading = false;
    //     state.error = action.payload as string;
    //   });
  },
});

export const { clearError, resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer; 